import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { colorsByType } from '../configs/colors';

const ChartLegend = ({ type = 'spline', options, className }) => {
  if (!options || !options.length) return null;

  const normalizedOptions = options.map((item, index) => ({
    value: index,
    label: item,
    color: colorsByType[type][index],
  }));

  return (
    <div className={cx('chart-legend', className)}>
      {normalizedOptions.map(({ value, label, color }) => (
        <div key={value} className="chart-legend__item">
          <div className="circle" style={{ backgroundColor: color }} />
          <p>{label}</p>
        </div>
      ))}
    </div>
  );
};

ChartLegend.propTypes = {
  type: T.oneOf(['spline', 'column']),
  options: T.arrayOf(T.string),
  className: T.string,
};

export default ChartLegend;
